module.exports = "\r\n <span class=\"wrapper {{^Model.Enabled}}disabled{{/Model.Enabled}}\">\r\n\r\n <label class=\"clearfix\">\r\n    <input data-material=\"{{Model.Name}}\" class=\"js-material {{^Model.Enabled}}disabled{{/Model.Enabled}}\" type=\"checkbox\">\r\n        <span><div class=\"text-cutoff\">{{Model.Label}}</div></span>\r\n        <span class=\"js-material-count\">{{Model.Count}}</span>\r\n </label>\r\n</span>\r\n{{#Model.HasSubFacets}}\r\n    <div class=\"children-region clearfix\"></div>\r\n{{/Model.HasSubFacets}}"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/material-filter.html
// module id = 418
// module chunks = 1